import React from "react";
// import Switch from "../Switch/Switch";

class RatesDashboardToggles extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const formatLastUpdated = (date) => {
      if (!date) return '';
      const lastUpdated = new Date(date);
      return ` (${lastUpdated.toLocaleDateString()} ${lastUpdated.toLocaleTimeString()})`;
    };

    return (
      <div className="RatesDashboardToggles form-group">

        <select
          name="rates_dashboard_toggle"
          className="form-control dashboard-view-select"
          value={this.props.toggleSetting}
          onChange={this.props.onChangeToggle}
        >
          <option value="prices">{I18n.t("view_price")}</option>
          <option value="minimum_stay">{I18n.t("view_minimum_stay")}</option>
          {this.props.daily_rentals_present ? <option value="daily_rentals">{I18n.t("view_daily_rentals")}</option> : null}
          <option value="table_view">{I18n.t("view_price_table")}{formatLastUpdated(this.props.prices_data_table_last_updated)}</option>
        </select>
      </div>
    );
  }
}

export default RatesDashboardToggles;
